
import { useState, useRef } from "react";
import { FormRow, FormRowSelect, FormRowSelectId, NavLinkButton } from "../";
import Wrapper from "../../assets/wrappers/DashboardFormPage";
import { Form, useSubmit, useLocation, useOutletContext } from "react-router-dom";
import { MESSAGE_TYPES, TARGET_TYPES } from "../../utils/messageConstants";
import { useAllMessagesContext } from "../../pages/ShowMessages";
import { Loading } from "../../components";

const MessageSearchContainer = () => {
  const { user } = useOutletContext();
  const submit = useSubmit();
  const { maintenanceCompanies } = useAllMessagesContext();
  const { search } = useLocation();
  const qs = new URLSearchParams(search);

  const [loading, setLoading] = useState(false);

  // useRef לשמירת מזהה ה־timeout בין קריאות
  const debounceTimeout = useRef(null);

  // useRef להפניה ל־<Form>, למקרה שצריך לעבר אותו ישירות
  const formRef = useRef(null);

  // 1) handler עבור שדה החיפוש (search) – debounce של 1100ms
  const handleSearchChange = (e) => {
    const formElement = e.currentTarget.form;

    // ננקה timeout קודם (אם קיים)
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // עיכוב של 1100ms (800 + 300)
    debounceTimeout.current = setTimeout(async () => {
      setLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
        // ניתן להוסיף טיפול בשגיאה במידת הצורך
      } finally {
        setLoading(false);
      }
    }, 1500);
  };

  // 2) handler עבור שדות Select (messageType, targetType, maintenanceCompany) – debounce של 100ms
  const handleSelectChange = (e) => {
    let formElement;

    if (e && e.target) {
      // עם אירוע רגיל: e.currentTarget.form
      formElement = e.currentTarget.form;
    } else {
      // במידה תקבלו ערך ישיר (לא אירוע), נוכל להשתמש ב־formRef
      formElement = formRef.current;
    }

    // ננקה timeout קודם
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // עיכוב קצר של 100ms
    debounceTimeout.current = setTimeout(async () => {
      setLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
        // טיפול בשגיאה אם נדרש
      } finally {
        setLoading(false);
      }
    }, 100);
  };

  return (
    <Wrapper>
      {/* 3) משייכים ref ל־Form */}
      <Form className="form" ref={formRef}>
        <h5 className="form-title">חיפוש הודעה</h5>
        {loading && <Loading />}

        <div className="form-center">
          {/* שדה טקסטואלי: debounce = 1100ms */}
          <FormRow
            name="search"
            type="search"
            placeholder="חיפוש לפי טקסט ההודעה"
            labelText="חיפוש"
            defaultValue={qs.get("search") || ""}
            handleChange={(e) => {
              handleSearchChange(e);
            }}
          />

          {/* שדה Select: debounce = 100ms */}
          <FormRowSelect
            labelText="סוג ההודעה"
            name="messageType"
            list={["הכל", ...Object.values(MESSAGE_TYPES)]}
            defaultValue={qs.get("messageType") || "הכל"}
            handleChange={(e) => {
              handleSelectChange(e);
            }}
          />

          {/* שדה Select נוסף: debounce = 100ms */}
          <FormRowSelect
            labelText="סוג היעד"
            name="targetType"
            list={["הכל", ...Object.values(TARGET_TYPES)]}
            defaultValue={qs.get("targetType") || "הכל"}
            handleChange={(e) => {
              handleSelectChange(e);
            }}
          />

          {/* שדה SelectId (חברת אחזקה): debounce = 100ms */}
          {user?.role === "admin" && (
            <FormRowSelectId
              name="maintenanceCompany"
              labelText="חברת אחזקה"
              list={[{ _id: "הכל", name: "הכל" }, ...maintenanceCompanies]}
              idField="_id"
              displayField="name"
              defaultValue={qs.get("maintenanceCompany") || "הכל"}
              handleChange={(e) => {
                handleSelectChange(e);
              }}
            />
          )}

          {/* כפתור ניקוי סינון */}
          <NavLinkButton
            text="ניקוי סינון"
            path="/dashboard/show-messages"
            icon="clear"
            color="#758694"
          />
        </div>
      </Form>
    </Wrapper>
  );
};

export default MessageSearchContainer;
